// extracted by mini-css-extract-plugin
export default {"accordionSection":"HelpFaq_accordionSection__a9IN1","mbaAccordion":"HelpFaq_mbaAccordion__7s1r5"};